import store from '../../store'

export function closeWhiteboardModal() {	
	store.dispatch({type:'HIDE_WHITEBOARD_MEDIA_MODAL'})
}
